import { Report } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api';

export function useCreatedReport(reportId: Report['id']) {
  return useQuery({
    queryKey: useCreatedReport.queryKey(reportId),
    queryFn: () => apiClient.reports.fetchReport(reportId),
  });
}

useCreatedReport.queryKey = (reportId: string) => ['report', reportId];
